import { MFA_AUTH_ENABLE } from '@organization/app-constants'
import { paths } from '@organization/router'
import { Tabs } from 'antd'
import { useTranslation } from 'react-i18next'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'

export const UserProfilePage = () => {
  const { t } = useTranslation()
  const location = useLocation()
  const navigate = useNavigate()

  const items = [
    {
      label: t('profile.config_profile'),
      key: paths.profile.root,
      children: <Outlet />
    },

    ...(MFA_AUTH_ENABLE
      ? [
          {
            label: t('profile.trusted_devices'),
            key: paths.profile.trustedDevices,
            children: <Outlet />
          }
        ]
      : [])
  ]

  return (
    <Tabs
      items={items}
      defaultActiveKey={location.pathname}
      onTabClick={(value) => navigate(value)}
    />
  )
}
